import * as browser from "webextension-polyfill";
import * as DOMPurify from "dompurify";
import latoRegular from "../../fonts/lato.woff?uri";
import latoExtRegular from "../../fonts/lato-ext-regular.woff?uri";
import latoExtItalic from "../../fonts/lato-ext-italic.woff?uri";
import latoItalic from "../../fonts/lato-italic.woff?uri";
import latoExtBoldItalic from "../../fonts/lato-ext-bolditalic.woff?uri";
import latoBoldItalic from "../../fonts/lato-bolditalic.woff?uri";
import latoExtBold from "../../fonts/lato-ext-bold.woff?uri";
import latoBold from "../../fonts/lato-bold.woff?uri";
import materialIconsRegular from "../../../icons/MaterialIcons-Regular.woff2?uri";
import dialogLogo from "../../../icons/adblock-20.svg?uri";
import dialogCss from "./dialog.css?text";
import dialogHtml from "./dialog.html?text";
import { isMessage } from "../../polyfills/shared/index";
import * as api from "../../../adblockplusui/js/api/index";
const fontsToLoad = [
    {
        src: latoRegular,
        style: "normal",
        weight: "normal",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
    },
    {
        src: latoExtRegular,
        style: "normal",
        weight: "normal",
        unicodeRange: "U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    },
    {
        src: latoExtItalic,
        style: "italic",
        weight: "normal",
        unicodeRange: "U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    },
    {
        src: latoItalic,
        style: "italic",
        weight: "normal",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
    },
    {
        src: latoExtBoldItalic,
        style: "italic",
        weight: "bold",
        unicodeRange: "U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    },
    {
        src: latoBoldItalic,
        style: "italic",
        weight: "bold",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
    },
    {
        src: latoExtBold,
        style: "normal",
        weight: "bold",
        unicodeRange: "U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    },
    {
        src: latoBold,
        style: "normal",
        weight: "bold",
        unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
    },
];
const divID = "__ABoverlay";
const defaultTopPosition = 37;
let intervalId;
const removeDialog = function () {
    var _a;
    const el = document.getElementById(divID);
    if (el) {
        (_a = el.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(el);
    }
    if (intervalId) {
        clearInterval(intervalId);
    }
};
function loadCss(base) {
    const styleElement = document.createElement("style");
    styleElement.textContent = dialogCss;
    base.appendChild(styleElement);
}
function loadLatoFont(src, style, weight, unicodeRange) {
    return new FontFace("Lato", `url("${src}")`, { style, weight, unicodeRange });
}
function loadResources(base) {
    loadCss(base);
    fontsToLoad.forEach((fontData) => {
        const { src, style, weight, unicodeRange } = fontData;
        document.fonts.add(loadLatoFont(src, style, weight, unicodeRange));
    });
    document.fonts.add(new FontFace("Material Icons", `url("${materialIconsRegular}")`, {
        style: "normal",
        weight: "normal",
    }));
}
function sendMessage(message) {
    return browser.runtime.sendMessage(message);
}
const showDialog = async function (message) {
    const mainBody = document.body;
    if (!mainBody) {
        return;
    }
    if (document.getElementById(divID)) {
        return;
    }
    const { content } = message;
    const { title, body, button } = content;
    const dialogParentElement = document.createElement("div");
    dialogParentElement.id = divID;
    const dialogElement = DOMPurify.sanitize(dialogHtml, { RETURN_DOM_FRAGMENT: true });
    if (DOMPurify.removed && DOMPurify.removed.length > 0) {
        return;
    }
    const closeIcon = dialogElement.querySelector("#closeIcon");
    if (closeIcon instanceof HTMLElement) {
        closeIcon.onclick = function closedClicked(event) {
            if (!event.isTrusted) {
                return;
            }
            sendMessage({ type: "onpage-dialog.close" });
        };
    }
    const adblockLogoElement = dialogElement.querySelector("#adblock-logo");
    if (adblockLogoElement instanceof HTMLImageElement) {
        adblockLogoElement.src = dialogLogo;
    }
    const titleTextElement = dialogElement.querySelector("#titleRow");
    titleTextElement.textContent = DOMPurify.sanitize(title);
    const bodyElement = dialogElement.querySelector("#bodySection");
    if (bodyElement instanceof HTMLElement) {
        for (const bodyText of body) {
            const paragraph = document.createElement("p");
            paragraph.classList.add("msgText");
            paragraph.textContent = DOMPurify.sanitize(bodyText);
            bodyElement.appendChild(paragraph);
        }
    }
    const btnContinue = dialogElement.querySelector("#continue");
    if (btnContinue instanceof HTMLElement) {
        if (button) {
            btnContinue.textContent = DOMPurify.sanitize(button);
            btnContinue.onclick = async function learnMoreClicked(event) {
                if (!event.isTrusted) {
                    return;
                }
                sendMessage({ type: "onpage-dialog.continue" });
            };
        }
        else {
            btnContinue.style.display = "none";
        }
    }
    const mode = navigator.webdriver ? "open" : "closed";
    const baseShadow = dialogParentElement.attachShadow({ mode });
    loadResources(baseShadow);
    setLangAndDirAttributes(dialogElement);
    const hostElement = baseShadow.host;
    if (hostElement instanceof HTMLElement) {
        hostElement.style.setProperty("--dialog-top-position", `${defaultTopPosition}px`);
    }
    baseShadow.appendChild(dialogElement);
    (document.body || document.documentElement).appendChild(dialogParentElement);
    let displayDuration = 0;
    intervalId = window.setInterval(() => {
        displayDuration += 1;
        sendMessage({ type: "onpage-dialog.ping", displayDuration });
    }, 60 * 1000);
    sendMessage({ type: "onpage-dialog.ping", displayDuration });
};
function handleMessage(message) {
    if (!isMessage(message)) {
        return;
    }
    switch (message.type) {
        case "onpage-dialog.hide":
            removeDialog();
            break;
        default:
    }
}
function isStartInfo(candidate) {
    return (candidate !== null &&
        typeof candidate === "object" &&
        "content" in candidate &&
        "localeInfo" in candidate);
}
async function start() {
    browser.runtime.onMessage.addListener(handleMessage);
    const startInfo = await sendMessage({ type: "onpage-dialog.get" });
    if (isStartInfo(startInfo)) {
        showDialog(startInfo);
    }
    api.addDisconnectListener(() => {
        removeDialog();
        browser.runtime.onMessage.removeListener(handleMessage);
    });
}
start();
